import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, defineAsyncComponent } from 'vue'

// 引入组件

export default /*#__PURE__*/_defineComponent({
  __name: 'register',
  setup(__props) {

const LoginContainer = defineAsyncComponent(() => import('./components/PageContainer.vue'));

const formState = ref({
  tabList: [
    { name: '注册笔熊分享账号', key: 'login-register' }
  ],
  activeKey: 'login-register'
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LoginContainer), { formState: formState.value }, null, 8, ["formState"]))
}
}

})